import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-task-requests-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './task-requests-page.component.html',
  styleUrl: './task-requests-page.component.css'
})
export class TaskRequestsPageComponent {

}
